export default {
  organizeList:[],
  dept:null,
  updateDept:null,
  deptSigner:null
};
